import gl from './gl';
import { GlobalRaf, GlobalResize } from './events';

// Initialize the events
GlobalRaf;
GlobalResize;

console.log('App initialized', gl);

